import { render, staticRenderFns } from "./chronicdisease.vue?vue&type=template&id=2641643c&"
import script from "./chronicdisease.vue?vue&type=script&lang=js&"
export * from "./chronicdisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports